$(document).on('turbolinks:load', function() {
  $('.datetimepicker').datetimepicker({
    dayViewHeaderFormat: 'YYYY年 MMM',
    format: 'YYYY-MM-DDTHH:mm:ss',
    locale: 'ja',
    showClose: true
  })
})
